export default __webpack_public_path__ + "static/media/PorcentajeSecondary.06512716.svg";